import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="bg-[#05071F] min-h-screen flex items-center justify-center font-body px-6">
      <div data-testid="payment-cancel-card" className="w-full max-w-md border border-white/10 bg-[#0B1035] p-10 text-center text-white">
        <XCircle className="w-10 h-10 text-slate-400 mx-auto" />
        <h1 className="mt-6 font-heading text-2xl font-medium">Payment cancelled</h1>
        <p className="mt-3 text-sm text-slate-400">No charge was made. You can reopen the payment link from your email anytime, or contact us with questions.</p>
        <Link to="/" className="mt-8 inline-block text-sm text-cyan-400 hover:text-cyan-300 transition-colors">← Back to Silent Sentry</Link>
      </div>
    </div>
  );
}
